import React from 'react';
import { IconHeart, LogoLinkedin, LogoFacebook, LogoTwitter, LogoInstagram, LogoYoutube } from '@sololearnorg/sol';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './AIFooter.scss';
import { LocalizedLink } from '../../../shared/public/LocalizedLink/LocalizedLink';
import { AuthService, Container, i18n } from '../../../symphony';
import { MobileStore, SlMobileStores } from '../../../shared/public/SlMobileStores/SlMobileStores';
import { openAIFlow } from '../../../../client/utils/openAIFlow';
import { LanguageSwitcher } from '../../../navigation/private/components/LanguageSwitcher/LanguageSwitcher';

export const AIFooter = () => {
  useStyles(s);
  const authService = Container.take('global', AuthService);

  const socialLinks = [
    {
      id: 0,
      link: 'https://www.linkedin.com/company/sololearn-inc-/',
      icon: <LogoLinkedin />,
      text: 'LinkedIn',
      color: '#0077b5',
    },
    {
      id: 1,
      link: 'https://www.facebook.com/SoloLearn',
      icon: <LogoFacebook />,
      text: 'Facebook',
      color: '#4267b2',
    },
    {
      id: 2,
      link: 'https://twitter.com/SoloLearn',
      icon: <LogoTwitter />,
      text: 'Twitter',
      color: '#1da1f2',
    },
    {
      id: 3,
      link: 'https://www.instagram.com/sololearn/',
      icon: <LogoInstagram />,
      text: 'Instagram',
    },
    {
      id: 4,
      link: 'https://www.youtube.com/channel/UCXiOyrjY_jqNCFoQTotILTw',
      icon: <LogoYoutube />,
      text: 'YouTube',
      color: 'red',
    },
  ];

  return (
    <footer className="sl-ai-footer">
      {!authService.isLoggedIn() && <div className="sl-ai-footer__cta">
        <h2>{i18n.t('ai-home.footer-cta-title')}</h2>
        <h4>{i18n.t('ai-home.footer-cta-subtitle')}</h4>
        <a onClick={openAIFlow}>{i18n.t('ai-home.start-learning-ai')}</a>
      </div>}

      <div className="sl-ai-footer__social">
        <div className="sl-ai-footer__social__container">
          <div className="sl-ai-footer__social__links-block">
            {socialLinks.map((link) => (
              <LocalizedLink
                className="sl-ai-footer__social__item"
                key={link.id}
                to={link.link}
                target="_blank"
              >
                <div
                  className="sl-ai-footer__social__icon"
                  style={link.color ? { color: link.color } : {}}
                >
                  {link.icon}
                </div>
                <span className="sl-ai-footer__social__text">
                  {link.text}
                </span>
              </LocalizedLink>
            ))}
          </div>
          <div className="sl-ai-footer__social__app-block">
            <SlMobileStores
              isAiSite
              classNames={{
                appStore: 'sl-ai-footer__social__item--app',
                playMarket: 'sl-ai-footer__social__item--app',
              }}
            />
          </div>
        </div>
      </div>

      <div className="sl-ai-footer__bottom">
        <div className="sl-ai-footer__links">
          <LocalizedLink to="/privacy-policy">{i18n.t('ai-home.footer-privacy-policy')}</LocalizedLink>
          <LocalizedLink to="/terms-of-use">{i18n.t('ai-home.footer-terms-of-use')}</LocalizedLink>
          <LocalizedLink to="/contact">{i18n.t('ai-home.footer-contact-us')}</LocalizedLink>
          <LanguageSwitcher showLabel={false} />
        </div>
        <div className="sl-ai-footer__copyright">
          {i18n.t('web-footer.made-by-before-heart')}
          <div className="sl-ai-footer__copyright__heart-icon">
            <IconHeart size={22} />
          </div>
          {i18n.t('web-footer.made-by-after-heart')}
          {' '}
          &nbsp;
          <span className="sl-ai-footer__copyright__marked-text">
            Sololearn
          </span>
          &nbsp;| ©
          {new Date().getFullYear()}
        </div>
      </div>

    </footer>
  );
};